import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAuthToken } from '../TokenContext';
import { useIntl, FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

const EpicsCountGraph = () => {
  const [epicsData, setEpicsData] = useState({ open_epics: 0, completed_epics: 0 });
  const { user } = useSelector((state) => state.auth);
  const intl = useIntl();
  const token = useAuthToken();

  useEffect(() => {
    fetchData();
  }, [token, user]);
  
  const fetchData = async () => {
    if (!token) return;
    if (!user?.data?.[0]) return;
    
    const type = (user.data[0].type || "").toLowerCase();
    if (type === "stakeholder") {
      await fetchStakeholderEpics();
    } else if (type === "candidate" || type === "talent") {
      await fetchTalentEpics();
    } else {
      await fetchManagerEpics();
    }
  };
  
  const fetchStakeholderEpics = async () => {
    try {
      let orgCode = user.data[0].client_code;
      if (orgCode && !orgCode.includes('#')) orgCode = `CLIENT#${orgCode}`;

      const payload = {
        org_code: orgCode,
        pod_id: [],
        sprint_name: ''
      };

      const type = (user.data[0].type || "").toLowerCase();
      const authHeader = type === "stakeholder" ? token : `Bearer ${token}`;
      const epicsUrl = process.env.REACT_APP_STAKEHOLDER_EPICSCOUNTMETRICSSTAKEHOLDER;

      const response = await fetch(epicsUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader,
        },
        body: JSON.stringify(payload),
      });
  
      const resJson = await response.json();
      console.log('>>> [EPICS DEBUG] Raw Stakeholder response:', resJson);
      const innerBody = resJson.body || resJson;
      const data = typeof innerBody === 'string' ? JSON.parse(innerBody) : innerBody;
      console.log('>>> [EPICS DEBUG] Parsed Stakeholder data:', data);
      
      // Resilient mapping for Epics
      const open = data.open_epics ?? data.open ?? data.Open ?? data.total_open_epics ?? 0;
      const done = data.completed_epics ?? data.completed ?? data.Complete ?? data.done ?? data.Done ?? data.total_completed_epics ?? 0;
      
      setEpicsData({ open_epics: open, completed_epics: done });
    } catch (error) {
      console.log('Error fetching stakeholder epics:', error);
    }
  };
  
  const fetchTalentEpics = async () => {
    try {
      const payload = {
        c_id: user.data[0].c_id,
        pod_id: [],
        sprint_name: ''
      };

      const response = await fetch(process.env.REACT_APP_TALENT_EPICSCOUNTTALENT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
  
      const data = await response.json();
      
      if (data?.body) {
        const bodyData = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
        setEpicsData(bodyData);
      }
    } catch (error) {
      console.log('Error fetching talent epics:', error);
    }
  };
  
  const fetchManagerEpics = async () => {
    try {      
      const payload = {
        manager_id: user.data[0].emp_id,
        pod_id: [],
        sprint_name: ''
      };

      const response = await fetch(process.env.REACT_APP_CLIENT_EPCCOUNTMANAGER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
  
      const data = await response.json();
      
      if (data?.body) {
        const bodyData = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
        setEpicsData(bodyData);
      }
    } catch (error) {
      console.log('Error fetching manager epics:', error);
    }
  };
  
  return (
    <div>
      <Typography variant="body2">
        {intl.formatMessage({ id: 'toDo' }, { defaultMessage: 'TO DO' })}: {epicsData.open_epics || 0}
      </Typography>
      <Typography variant="body2">
        {intl.formatMessage({ id: 'Done' }, { defaultMessage: 'DONE' })}: {epicsData.completed_epics || 0}
      </Typography>
    </div>
  );
};

export default EpicsCountGraph;